import { render } from "./FnbExtrasCosts.vue?vue&type=template&id=5d31f730&scoped=true"
import script from "./FnbExtrasCosts.vue?vue&type=script&lang=js"
export * from "./FnbExtrasCosts.vue?vue&type=script&lang=js"

import "./FnbExtrasCosts.vue?vue&type=style&index=0&id=5d31f730&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d31f730"]])

export default __exports__